import api from './api';

export interface WebhookSettings {
  url: string;
  isActive: boolean;
  configured: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface WebhookTestResult {
  testSent: boolean;
  webhookUrl: string;
  testPayload: any;
}

class WebhookService {
  /**
   * Get current webhook settings
   */
  async getWebhookSettings(): Promise<WebhookSettings> {
    const response = await api.get('/webhooks/settings');
    return response.data.data;
  }

  /**
   * Save webhook settings
   */
  async saveWebhookSettings(url: string, isActive: boolean = true): Promise<WebhookSettings> {
    const response = await api.post('/webhooks/settings', {
      url,
      isActive
    });
    return response.data.data;
  }

  /**
   * Test webhook connection
   */
  async testWebhookConnection(): Promise<WebhookTestResult> {
    const response = await api.post('/webhooks/settings/test');
    return response.data.data;
  }

  /**
   * Validate webhook URL format
   */
  validateWebhookUrl(url: string): { isValid: boolean; error?: string } {
    if (!url || typeof url !== 'string') {
      return { isValid: false, error: 'URL is required' };
    }

    if (!url.trim()) {
      return { isValid: false, error: 'URL cannot be empty' };
    }

    try {
      const urlObj = new URL(url);
      
      if (!['http:', 'https:'].includes(urlObj.protocol)) {
        return { isValid: false, error: 'URL must use HTTP or HTTPS protocol' };
      }

      // Recommend HTTPS for production
      if (urlObj.protocol === 'http:' && process.env.NODE_ENV === 'production') {
        return { isValid: false, error: 'HTTPS is required for production environments' };
      }

      return { isValid: true };
    } catch {
      return { isValid: false, error: 'Invalid URL format' };
    }
  }
}

export const webhookService = new WebhookService();
export default webhookService;